import * as React from 'react';
import api from './ApiClient';

interface SeriesClass {
	id: string;
	name: string;
	divisionId?: string | null;
}

interface ClassSelectorProps {
	seriesId: string;
	divisionId?: string;
	onChange: (classid: string) => void;
	showAllButton?: boolean;
}

interface ClassSelectorState {
	seriesClasses: SeriesClass[];
	classId: string;
}

export default class ClassSelector extends React.Component<ClassSelectorProps, ClassSelectorState> {

	state: ClassSelectorState = {
		seriesClasses: [],
		classId: ''
	};

	componentDidMount() {
		if (this.props.seriesId) {
			this.loadClasses(this.props.seriesId);
		}
	}

	componentDidUpdate(prevProps: ClassSelectorProps) {
		if (prevProps.seriesId !== this.props.seriesId) {
			this.loadClasses(this.props.seriesId);
		}
		
		// Reset selection when division changes
		if (prevProps.divisionId !== this.props.divisionId) {
			this.changeClassId('');
		}
	}

	loadClasses(seriesId: string) {
		api.request('seriesclasses/?seriesId=' + seriesId).then((data: SeriesClass[]) => {
			this.setState({ seriesClasses: data });

			if (!this.props.showAllButton && data.length > 0) {
				this.changeClassId(data[0].id);
			}
		});
	}

	changeClassId = (classId: string) => {
		this.setState({ classId: classId });
		this.props.onChange(classId);
	}

	getFilteredClasses(): SeriesClass[] {
		const { divisionId } = this.props;
		const { seriesClasses } = this.state;
		
		if (!divisionId) {
			return seriesClasses;
		}
		
		return seriesClasses.filter(sc => sc.divisionId === divisionId);
	}

	render() {
		const filteredClasses = this.getFilteredClasses();
		
		return (
			<div className="btn-group" role="group" aria-label="Class selector" style={{ display: 'block' }}>
				{this.props.showAllButton && (
					<button
						onClick={() => this.changeClassId('')}
						className={this.state.classId === '' ? 'btn btn-primary' : 'btn btn-outline-secondary'}
					>
						All Classes
					</button>
				)}
				{filteredClasses.length === 0 && !this.props.showAllButton && (
					<div className="alert alert-info">
						No classes available for the selected division.
					</div>
				)}
				{filteredClasses.map(sc => (
					<button
						className={this.state.classId === sc.id ? 'btn btn-primary' : 'btn btn-outline-secondary'}
						key={sc.id}
						onClick={() => this.changeClassId(sc.id)}
					>
						{sc.name}
					</button>
				))}
			</div>
		);
	}
}